import React, { useContext, useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Icon, Header, Button } from 'semantic-ui-react';
import TechnicianTransmissionStore from "../../../app/stores/techniciantransmissionStore";

interface IProps {
  id: string;
  siteId: string;
  category: string;
}

const dropzoneStyles = {
  // border: 'dashed 3px',
  // borderColor: '#eee',
  // borderRadius: '5px',
  // paddingTop: '30px',
  textAlign: 'center' as 'center',
  // height: '50px'
};

const dropzoneActive = {

  borderColor: 'green'
};



const TransmissionPhotoDropzone: React.FC<IProps> = ({ id, siteId, category }) => {
  const techniciantransmissionStore = useContext(TechnicianTransmissionStore);
  const {
    uploadTransmissionPhoto,
  } = techniciantransmissionStore;

  const onDrop = useCallback(acceptedFiles => {
    uploadTransmissionPhoto(acceptedFiles, id, siteId, category).then(()=> acceptedFiles.length = 0);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <section>
      <div
        {...getRootProps()}
        style={
          isDragActive ? { ...dropzoneStyles, ...dropzoneActive } : dropzoneStyles
        }
      >
        <input {...getInputProps()} />
        Upload

      </div>
      {/* <ul>{files}</ul> */}

    </section>
  );
};

export default TransmissionPhotoDropzone;
